import { render, staticRenderFns } from "./RightSide.vue?vue&type=template&id=9867c19c&scoped=true"
import script from "./RightSide.vue?vue&type=script&lang=js"
export * from "./RightSide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9867c19c",
  null
  
)

export default component.exports